export const HomeHeroSectionMock = [
  {
    "name": "Beach",
    "url": "/3d-models/beach",
    "icon": "Ꙛ",
    "position": 1,
  },
  {
    "name": "Ice Cream",
    "url": "/3d-models/ice-cream",
    "icon": "Ꙛ",
    "position": 2,
  },
  {
    "name": "Palm Tree",
    "url": "/3d-models/palm-tree",
    "icon": "Ꙛ",
    "position": 3,
  },
  {
    "name": "Sunglasses",
    "url": "/3d-models/sunglasses",
    "icon": "Ꙛ",
    "position": 4,
  },
  {
    "name": "Swimming Pool",
    "url": "/3d-models/swimming-pool",
    "icon": "Ꙛ",
    "position": 5,
  },
  {
    "name": "Coconut",
    "url": "/3d-models/coconut",
    "icon": "Ꙛ",
    "position": 6,
  },
  {
    "name": "Newest",
    "url": "/3d-models/newest",
    "icon": "Ꙛ",
    "position": 7,
  },
  {
    "name": "Top Selling",
    "url": "/3d-models/top-selling",
    "icon": "Ꙛ",
    "position": 8,
  },
]
